import { patientConcessionCardClient } from '@/api/patients/patientConcessionCardClient';
import { QueryKey } from '@/data/query';

const queryClient = patientConcessionCardClient();

export type ConcessionCardData = {
  patientId?: number | null;
  id?: number;
  cardType?: 'HEALTH_CARE' | 'PENSIONER' | 'COMMONWEALTH_SENIOR' | 'VETERANS_CARD_HOLDER' | 'ATSI';
  cardNumber?: string | null;
  expiryYear?: number | null;
  expiryMonth?: number | null;
  expiryDay?: number | null;
  documentIdentifier?: string | null;
  createdDate?: string | null;
  modifiedDate?: string | null;
  hasValidConcessionCard?: boolean;
};

export const useGetPatientConcessionCard = (patientId: number | undefined) => {
  const queryResult = queryClient.getPatientConcessionCard.useQuery({
    queryKey: [QueryKey.GetPatientConcessionCard, patientId],
    queryData: {
      params: { id: Number(patientId) }
    },
    enabled: Boolean(patientId)
  });
  const concessionCardData: ConcessionCardData = {
    ...queryResult.data?.body?.data?.attributes,
    id: queryResult.data?.body?.data?.id,
    cardType: queryResult.data?.body?.data?.attributes?.cardType as ConcessionCardData['cardType']
  };

  return {
    data: queryResult.data?.body?.data ? concessionCardData : null,
    isError: queryResult.isError,
    isLoading: queryResult.isLoading,
    refetch: queryResult.refetch
  };
};
